__turbopack_context__.v({
  "clickable": "WalletDetailCard-module__SNjpza__clickable",
  "copied": "WalletDetailCard-module__SNjpza__copied",
  "detailName": "WalletDetailCard-module__SNjpza__detailName",
  "detailNameText": "WalletDetailCard-module__SNjpza__detailNameText",
  "icon": "WalletDetailCard-module__SNjpza__icon",
  "root": "WalletDetailCard-module__SNjpza__root",
  "skele": "WalletDetailCard-module__SNjpza__skele",
  "walletDetailItemHead": "WalletDetailCard-module__SNjpza__walletDetailItemHead",
});
